import {
  IInquiry,
  IApplicant,
  IApiInquiry,
  IApiApplicant,
  IApiPropertyDetails,
  IPropertyDetails
} from './types'

// DESERIALIZE ------------------------------------------------------------------

function deserializeApplicant(apiApplicant: IApiApplicant) {
  const applicant: IApplicant = {
    date_of_birth: apiApplicant.date_of_birth,
    expected_retirement_age: apiApplicant.expected_retirement_age,
    employment_type: apiApplicant.employment_type,
    annual_gross_income: null,
    credit_card_debt: null,
    monthly_loan_payments: null,
    monthly_other_outgoings: null
  }
  if (apiApplicant.annual_gross_income) {
    applicant.annual_gross_income = apiApplicant.annual_gross_income
  }
  if (apiApplicant.credit_card_debt) {
    applicant.credit_card_debt = apiApplicant.credit_card_debt
  }
  if (apiApplicant.monthly_loan_payments) {
    applicant.monthly_loan_payments = apiApplicant.monthly_loan_payments
  }
  if (apiApplicant.monthly_other_outgoings) {
    applicant.monthly_other_outgoings = apiApplicant.monthly_other_outgoings
  }

  return applicant
}

function deserializePropertyDetails(apiProperty: IApiPropertyDetails) {
  const property: IPropertyDetails = {
    postcode: apiProperty.postcode,
    property_type: apiProperty.property_type,
    ownership_type: apiProperty.ownership_type,
    num_bedrooms: apiProperty.num_bedrooms,
    annual_council_tax: null,
    annual_building_insurance: null,
    annual_ground_rent: null,
    annual_service_fee: null
  }
  if (apiProperty.annual_council_tax) {
    property.annual_council_tax = apiProperty.annual_council_tax
  }
  if (apiProperty.annual_building_insurance) {
    property.annual_building_insurance = apiProperty.annual_building_insurance
  }
  if (apiProperty.annual_ground_rent) {
    property.annual_ground_rent = apiProperty.annual_ground_rent
  }
  if (apiProperty.annual_service_fee) {
    property.annual_service_fee = apiProperty.annual_service_fee
  }

  return property
}

export function deserializeInquiry(calculatorId: string, apiInquiry: IApiInquiry) {
  const inquiry: IInquiry = {
    calculatorId,
    status: 'CALCULATING',
    id: apiInquiry.id,
    user: apiInquiry.user,
    deposit: apiInquiry.deposit || null,
    num_dependants: apiInquiry.num_dependants || null,
    monthly_child_care_costs: apiInquiry.monthly_child_care_costs || null,
    property_purchase_price: null,
    loan_amount: null,
    primary_applicant: deserializeApplicant(apiInquiry.primary_applicant),
    secondary_applicant: null
  }
  if (apiInquiry.property_purchase_price) {
    inquiry.property_purchase_price = apiInquiry.property_purchase_price
  }
  if (apiInquiry.loan_amount) {
    inquiry.loan_amount = apiInquiry.loan_amount
  }
  if (apiInquiry.secondary_applicant) {
    inquiry.secondary_applicant = deserializeApplicant(apiInquiry.secondary_applicant)
  }
  if (apiInquiry.property_details) {
    inquiry.property_details = deserializePropertyDetails(apiInquiry.property_details)
  }
  if (apiInquiry.answer) {
    inquiry.answer = apiInquiry.answer
  }

  return inquiry
}
